import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import PartMaster from "./pages/PartMaster";
import AddlText2 from "./pages/AddlText2";
import Reports from "./pages/Reports";
import ChangePassword from "./pages/ChangePassword";
import { PartsProvider } from "./context/PartsContext";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<PartsProvider><Dashboard /></PartsProvider>} />
        <Route path="/partmaster" element={<PartsProvider><PartMaster /></PartsProvider>} />
        <Route path="/addltxt2" element={<AddlText2 />} />
        <Route path="/reports" element={<PartsProvider><Reports /></PartsProvider>} />
        <Route path="/changepassword" element={<ChangePassword />} />
      </Routes>
    </Router>
  );
}

export default App;